// src/views/About.js
import React, { useState, useCallback } from 'react'; // Import useState and useCallback
import styles from './About.module.css'; // Assuming you have an About.module.css
import FeedbackModal from '../components/FeedbackModal'; // Import the FeedbackModal component

// --- Feedback Modal Constants (UNIQUE FOR ABOUT PAGE) ---
const FEEDBACK_FORM_URL = "https://docs.google.com/forms/d/e/1FAIpQLSfCYQQ3NJS3nRLoVB9Q1LtELQxQizAD37t1LMwJ_5-ei2dryA/viewform?usp=dialog"; // Use the same URL for consistency
// Local Storage Keys (unique for About page)
const LS_KEY_LAST_PROMPT_TIME_ABOUT = 'about_last_prompt_time';
const LS_KEY_DISMISSED_PERMANENTLY_ABOUT = 'about_dismissed_permanently';
const LS_KEY_ABOUT_FIRST_COMPLETED = 'about_first_completed'; // To track first interaction
// --- End Feedback Modal Constants ---


// Receive onOpenDonationModal as a prop from App.js
const About = ({ onOpenDonationModal }) => {
    // State for Feedback Modal
    const [showFeedbackModal, setShowFeedbackModal] = useState(false);

    // Define the inline style object for the full page background
    const backgroundStyle = {
        backgroundImage: 'url("/images/about.jpg")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundColor: '#0A4D68', // Consistent Deep Teal fallback
        minHeight: '100vh', // Ensure it covers the full viewport height
        display: 'flex', // Use flexbox to center content vertically
        flexDirection: 'column', // Stack content vertically
        alignItems: 'center', // Center content horizontally
        justifyContent: 'flex-start', // Align content to the start (top)
        padding: '60px 20px 80px 20px', // Add top/bottom padding for content, and side padding
        boxSizing: 'border-box', // Include padding in element's total width and height
    };

    // --- Feedback Modal Handlers ---
    const handleOpenFeedbackModal = useCallback(() => {
        const dismissedPermanently = localStorage.getItem(LS_KEY_DISMISSED_PERMANENTLY_ABOUT) === 'true';

        if (!dismissedPermanently) {
            setShowFeedbackModal(true);
            // Mark as first time completed from About page (if not already)
            if (localStorage.getItem(LS_KEY_ABOUT_FIRST_COMPLETED) !== 'true') {
                localStorage.setItem(LS_KEY_ABOUT_FIRST_COMPLETED, 'true');
            }
            localStorage.setItem(LS_KEY_LAST_PROMPT_TIME_ABOUT, Date.now().toString()); // Update last prompt time
        } else {
            console.log("Feedback modal dismissed permanently for About page. Not opening.");
        }
    }, []);

    const handleCloseFeedbackModal = useCallback(() => {
        setShowFeedbackModal(false);
    }, []);

    const handleDismissFeedbackPermanently = useCallback(() => {
        localStorage.setItem(LS_KEY_DISMISSED_PERMANENTLY_ABOUT, 'true');
        localStorage.setItem(LS_KEY_ABOUT_FIRST_COMPLETED, 'true'); // Also mark as first-time completed
        setShowFeedbackModal(false);
    }, []);
    // --- End Feedback Modal Handlers ---

    return (
        // Apply background style to the outermost div
        <div className={styles.aboutPageWrapper} style={backgroundStyle}>
            {/* This container will now simply control the max-width and centering of the text content */}
            <div className={styles.contentContainer}>

                {/* New sections for Our Approach and Why We Built DeenRoute */}
                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Our Approach</h2>
                    <p className={styles.sectionContent}>
                        We blend modern UI/UX with authentic Islamic content, backed by Quran and Sahih Hadith references. Our diverse
                        activities support various learning styles, keeping users engaged and encouraging deeper exploration.
                    </p>
                </section>

                <section className={styles.section}>
                    <h2 className={styles.sectionTitle}>Why We Built DeenRoute</h2>
                    <p className={styles.sectionContent}>
                        In today’s digital age, DeenRoute addresses language barriers, information overload, and the need for truly interactive
                        Islamic learning. Designed for reverts, children, and lifelong learners, it makes gaining knowledge fun, personal, and rewarding.
                    </p>
                </section>

                {/* Support DeenRoute Section */}
                <section className={`${styles.section} ${styles.supportSection}`}>
                    <h2 className={styles.sectionTitle}>Support Our Mission</h2>
                    <p className={styles.sectionContent}>
                        DeenRoute is built to serve the Ummah. Your support helps us grow, stay accessible, and continue adding content and features. If you
                        believe in our mission, please consider donating. JazakAllah Khair!
                    </p>
                    <div className={styles.buttonGroup}> {/* Added a div for button grouping */}
                        <button
                            onClick={onOpenDonationModal} // Call the handler passed from App.js
                            className={styles.supportButton} // Apply specific style for this button
                        >
                            Support DeenRoute
                        </button>
                        {/* NEW: Feedback Button */}
                        {/* Using the same button style for consistency */}
                        <button
                            onClick={handleOpenFeedbackModal}
                            className={styles.supportButton}
                        >
                            Give Feedback
                        </button>
                    </div>
                </section>
                {/* End Support DeenRoute Section */}

                <p className={styles.founderInfo}>
                    Founder - Richard Magnus-Oyewole
                </p>
            </div>

            {/* NEW: Feedback Modal Render */}
            <FeedbackModal
                isOpen={showFeedbackModal}
                onClose={handleCloseFeedbackModal}
                onDismissPermanently={handleDismissFeedbackPermanently}
                formUrl={FEEDBACK_FORM_URL}
                gameName="DeenRoute" // Unique name for feedback context
            />
            {/* End NEW Feedback Modal Render */}
        </div>
    );
};

export default About;
